import { observer } from "mobx-react-lite";
import { XStack, YStack } from "tamagui";
import { Box } from "../ui/Box";
import { Button } from "../ui/Button";
import { Group } from "../ui/Group";
import { Title } from "../ui/Title";
import type PlanModel from "./PlanModel";

export const PlanUsersWaitingForApproval: React.FC<{ plan: PlanModel }> =
  observer(({ plan }) => {
    const waitingUsers = plan.usersWaitingForApproval;

    if (waitingUsers.length === 0) {
      return null;
    }

    return (
      <Box flex={1} borderBottomColor={"$divider"} borderBottomWidth={1}>
        <YStack gap={"$medium"}>
          <Title>Users waiting to join</Title>
          <Group>
            {plan.usersWaitingForApproval.map((user) => (
              <XStack
                key={user.uid}
                justifyContent="space-between"
                alignItems="center"
                width={"100%"}
              >
                {user.data.displayName}

                <XStack gap={"$medium"}>
                  <Button
                    type={"secondary"}
                    onPress={() => {
                      plan.denyUser(user.uid);
                    }}
                  >
                    Deny
                  </Button>
                  <Button
                    type={"primary"}
                    onPress={() => {
                      plan.acceptUser(user.uid);
                    }}
                  >
                    Accept
                  </Button>
                </XStack>
              </XStack>
            ))}
          </Group>
        </YStack>
      </Box>
    );
  });
